import { defaultTo } from 'lodash';
import { IModel, Model, ModelRecord } from './Model';

export interface IHospitalPrescriptionEventTypeModel extends IModel {
  hospitalPrescriptionEventTypeId: number;
  name: string;
}

export class HospitalPrescriptionEventTypeModel
  extends Model
  implements ModelRecord<HospitalPrescriptionEventTypeModel>
{
  hospitalPrescriptionEventTypeId: number;
  name: string;

  constructor(params?: Partial<IHospitalPrescriptionEventTypeModel>) {
    super(params);
    this.hospitalPrescriptionEventTypeId = defaultTo(
      params?.hospitalPrescriptionEventTypeId,
      0,
    );
    this.name = defaultTo(params?.name, '');
  }
}
